import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import get from 'lodash/get';
import MuiRadio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';

import { FormLabel } from '@material-ui/core';
import classes from './Radio.module.scss';

const Radio = (props) => {
  const { radioProps = {}, className } = props;
  const { formProps, name, options = [], disabled, label, ...other } = radioProps;
  const commonProps = {
    value: get(formProps, `values.${name}`, ''),
    errorText: get(formProps, `errors.${name}`, ''),
    touched: get(formProps, `touched.${name}`, ''),
    onChange: get(formProps, 'handleChange'),
    ...other,
  };
  const { touched, errorText } = commonProps;
  return (
    <div className={clsx(classes.wrapper, className)}>
      <FormControl
        component='fieldset'
        className={clsx(classes.formControl, touched && !!errorText ? classes.error : '')}>
        {label && <FormLabel>{label}</FormLabel>}
        <RadioGroup aria-label='gender' name={name} {...commonProps}>
          {options.map((o) => {
            return (
              <FormControlLabel
                value={o.value}
                control={<MuiRadio classes={{ root: classes.radio }} />}
                label={o.label}
                disabled={o.diabled || disabled}
              />
            );
          })}
        </RadioGroup>
      </FormControl>
    </div>
  );
};

Radio.propTypes = {
  radioProps: PropTypes.object.isRequired,
};

export default Radio;
